import { Trans, i18nMark } from '@lingui/react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { CourseType, courseViewMode } from 'common-proptypes'
import ProductName from 'components/ProductName'
import CourseSection from './CourseSection.jsx'

import styles from './CourseDetails.module.scss'

/* eslint-disable react/no-danger */

export default class CourseDetailsRenderer extends React.PureComponent {
  static propTypes = {
    course: CourseType.isRequired,
  }

  render() {
    const { course } = this.props
    const {
      name,
      description,
      sections,
    } = course

    function getSectionLockedReason(section) {
      if(course.viewMode !== courseViewMode.SEQUENTIAL) {
        return null
      }
      if(section.complete) {
        return null
      }
      const previousSection = sections[sections.indexOf(section) - 1]
      if(!previousSection) {
        return null
      }
      if(!previousSection.complete) {
        return i18nMark('This section will be available when you complete the previous section')
      }
      return null
    }

    const $sections = sections.map(section => {
      const lockReason = getSectionLockedReason(section)
      return (
        <CourseSection
          key={section.name}
          locked={!!lockReason}
          lockReason={lockReason}
          section={section}
        />
      )
    })
    const $expires = course.expiresOn && (
      <div className={styles.expires}>
        <Trans
          id="This course will expire {expiresFromNow}"
          values={{ expiresFromNow: moment(course.expiresOn).fromNow() }}
        />
      </div>
    )
    return (
      <div className={styles.root}>
        <header>
          <div>
            <h1><Trans>Assigned Courses</Trans></h1>
            <Link
              to="/"
              className="button-arrow-left"
            >
              <Trans>View All Online Courses</Trans>
            </Link>
          </div>
          <h2 className={styles.courseName}><ProductName name={name} block /></h2>
          {description && (
            <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
          )}
          {$expires}
          <p>{window.getCourseHeaderMessage()}</p>
        </header>
        {/*
        <p>
          <strong>
            <Plural
              value={sections.length}
              _0="This course contains no sections."
              _1="This course requires you to complete this section in full."
              other="This course requires you to complete the following # sections in full."
            />
          </strong>
        </p>
        */}
        <article>
          {$sections}
        </article>
      </div>
    )
  }
}
